import React, { useEffect, useRef, useState } from 'react';
import StageResultTable from './StageResultTable';
import ResultAfterStage from './ResultAfterStageTable';
import StageTestResultTable from './StageTestResult';
import GroupDropdown from './GroupDropdown';
import useStageResults from '../../../useStageResults';
import { normalizeGroupValue } from '../utils/group';
import ConnectionStatusIndicator from './ConnectionStatusIndicator';
import './connectionStatus.css';

const DesktopResults = ({
  selectedCompetition,
  selectedEventID,
  selectedCompetitionID,
  selectedGroupID,
  selectedStageID,
  stageStatusDesc,
  selectedStageStatus,
  selectedClassificationID,
  stageIsTested,
  selectedGroupList,
  onGroupChange,
}) => {
  const [selectedDropdownOption, setSelectedDropdownOption] = useState(
    normalizeGroupValue(selectedGroupID)
  );

  const { stageResults, afterStageResults, loading, error } = useStageResults(
    selectedEventID,
    selectedCompetitionID,
    selectedStageID,
    selectedClassificationID,
    selectedDropdownOption
  );
  useEffect(() => {
    setSelectedDropdownOption(normalizeGroupValue(selectedGroupID));
  }, [selectedGroupID]);

  const columnsRef = useRef(null);

  useEffect(() => {
    const frame = requestAnimationFrame(() => {
      const el = columnsRef.current;
      if (!el) return;
      const [left, right] = el.children;
      if (!left || !right) return;
      const leftRows = left.querySelectorAll('tbody tr');
      const rightRows = right.querySelectorAll('tbody tr');
      leftRows.forEach((r) => { r.style.height = ''; });
      rightRows.forEach((r) => { r.style.height = ''; });
      const count = Math.min(leftRows.length, rightRows.length);
      const heights = [];
      for (let i = 0; i < count; i++) {
        heights.push(Math.max(leftRows[i].offsetHeight, rightRows[i].offsetHeight));
      }
      for (let i = 0; i < count; i++) {
        leftRows[i].style.height = heights[i] + 'px';
        rightRows[i].style.height = heights[i] + 'px';
      }
    });
    return () => cancelAnimationFrame(frame);
  }, [stageResults, afterStageResults]);

  const handleDropdownChange = (newValue) => {
    const normalizedValue = normalizeGroupValue(newValue);
    setSelectedDropdownOption(normalizedValue);
    if (typeof onGroupChange === 'function') {
      onGroupChange(normalizedValue);
    }
  };

  if (selectedStageStatus) {
    return (
      <div className="section">
        <div className="notification has-text-centered mt-1">
          <p>Odcinek odwołany {stageStatusDesc}</p>
        </div>
      </div>
    );
  }

  if (stageIsTested) {
    return (
      <StageTestResultTable
        selectedCompetition={selectedCompetition}
        selectedEventID={selectedEventID}
        selectedCompetitionID={selectedCompetitionID}
        selectedGroupID={selectedGroupID}
        selectedStageID={selectedStageID}
        selectedClassificationID={selectedClassificationID}
      />
    );
  }

  const stageFinisherNumbers = new Set(
    stageResults
      .filter(r => r.rowNumber !== 'OUT')
      .map(r => r.positionNumber)
  );

  const filteredAfterStageResults = stageResults.length > 0
    ? afterStageResults.filter(r => stageFinisherNumbers.has(r.positionNumber) || r.rowNumber === 'OUT')
    : [];

  return (
    <div className="dskt-table-container">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap' }}>
        <GroupDropdown
          options={Array.isArray(selectedGroupList)
            ? selectedGroupList.map((option) => ({
                label: option.name,
                value: option.value,
              }))
            : []}
          value={selectedDropdownOption}
          onSelectionChange={handleDropdownChange}
        />
        <ConnectionStatusIndicator />
      </div>
      <div className="columns" ref={columnsRef}>
        <StageResultTable results={stageResults} loading={loading} error={error} />
        <ResultAfterStage results={filteredAfterStageResults} loading={loading} error={error} />
      </div>
    </div>
  );
};

export default DesktopResults;
